import { IconPencil, IconTrash, IconUserStar } from "@tabler/icons-react";
import { getInitials, colourForName } from "./data";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";
import Button from "../UI/Button/button";

const MAX_SHOWN = 4;


export default function TeamCard({ team, canWrite, onEdit, onDelete }) {
  const members = team?.members || [];
  const shown = members?.slice(0, MAX_SHOWN);
  const extra = (team?.memberCount ?? members?.length) - shown?.length;

  return (
    <div className={styles.teamCard}>
      <div
        className={styles.teamCardAccent}
        style={{ background: team.colour }}
      />

      <div className={styles.teamCardHeader}>
        <div>
          <div className={styles.teamCardName}>{team?.name}</div>
          <div className={styles.teamCardMeta}>
            {team?.description || "No description"}
          </div>
        </div>
        {canWrite && (
          <div className={styles.teamCardActions}>
            <Button
              variant="icon"
              size="sm"
              className={styles.rowIconBtn}
              aria-label="Edit team"
              onClick={() => onEdit(team?._id)}
            >
              <IconPencil size={15} />
            </Button>
            <Button
              variant="icon"
              size="sm"
              className={`${styles.rowIconBtn} ${styles.rowIconDanger}`}
              aria-label="Delete team"
              onClick={() => onDelete(team?._id)}
            >
              <IconTrash size={15} />
            </Button>
          </div>
        )}
      </div>

      <div className={styles.memberStack}>
        {members.length === 0 && (
          <span className={styles.noMembersText}>No members yet</span>
        )}
        {shown.map((m) => (
          <div
            key={m._id}
            className={styles.memberAvatar}
            style={{ background: colourForName(m.name) }}
            title={m.name}
          >
            {getInitials(m.name)}
          </div>
        ))}
        {extra > 0 && <div className={styles.memberCountBadge}>+{extra}</div>}
      </div>

      <div className={styles.teamCardFooter}>
        <div className={styles.teamManager}>
          <IconUserStar size={14} />
          {team?.managerId?.name || "No manager"}
        </div>
        <span className={styles.teamMemberCount}>
          {team?.memberCount ?? members?.length} member
          {(team?.memberCount ?? members?.length) !== 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
}
